
import FileFlagStatusChip from './FileFlagStatusChip.vue';
import fileService from '@/services/ProjectFileService';
import FileStatusChip from './FileStatusChip.vue';
import HasDataTable from '@/components/hoc/HasDataTable';
import MxDataTable from '@/components/global/MxDataTable.vue';
import UserGroupSelector from '@/components/users/UserGroupSelector.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import {  FileStatus, IProjectFile } from '@/types/resource.types';
import { IPaginatedRequest, IPaginatedResult } from '@/types/services.types';
import { paths } from '@/router/route-paths';

@Component({
    name: 'ProjectsTable',
    components: {
        FileStatusChip,
        FileFlagStatusChip,
        MxDataTable,
        UserGroupSelector
    }
})
export default class ProjectsTable extends HasDataTable {

    /* Props
    ============================================*/

    @Prop({type: Object, required: false})
    readonly initialRequest: IPaginatedRequest;


    /* Data
    ============================================*/

    processingComplete: FileStatus = FileStatus.ProcessingComplete;
    loadingFiles: boolean = false;
    filesResult: IPaginatedResult<IProjectFile> | null = null;

    /* Computed
    ============================================*/

    get headers() {
        return fileTableHeadersSmall;
    }

    /* Methods
    ============================================*/

    getItemClass(file: IProjectFile) {
        if(file.status === FileStatus.ProcessingComplete) return 'pointer';
        return '';
    }

    goToFile(file: IProjectFile) {
        if(!file.id) return;
        if(file.status !== FileStatus.ProcessingComplete) return;
        this.$router.push(paths.FILE_ANALYSIS(file.id));
    }

    async searchFiles(req: IPaginatedRequest) {
        try {
            this.loadingFiles = true;
            let filesResult = await fileService.getMatched(req);
            this.filesResult = filesResult;
        } catch(e) {
            this.$logger.logError(e);
            this.$toast.error('There was a problem loading the file list. Please try again.');
        } finally {
            this.loadingFiles = false;
        }
    }

}

export const fileTableHeadersSmall: DataTableHeader<IProjectFile>[] = [
    
    {
        text: 'File Id',
        value: 'id'
    },
    {
        text: 'Case',
        value: 'project.caseId'
    },
    {
        text: 'Matched',
        value: 'updated'
    }
];

